import {createAsyncAction, createStandardAction} from "typesafe-actions";
import {ITutorialRequest, TutorialKey} from "./types";

export const showTutorial = createAsyncAction(
    '@tutorial/SHOW_TUTORIAL_REQUEST',
    '@tutorial/SHOW_TUTORIAL_SUCCESS',
    '@tutorial/SHOW_TUTORIAL_FAILED'
)<ITutorialRequest, TutorialKey, TutorialKey>();

export const closeTutorial = createStandardAction('@tutorial/CLOSE_TUTORIAL')<TutorialKey>();